import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { clearGlobalPopUpWrapper } from '../actions';
import { IN_REQUEST_INF_TYPE_ENUM, POPUP_LIST_NAME, USER_TYPE } from '../../../configs';
import {
  dateFormatter,
  dateTimeFormatter, formatFioForAvatar, getLegalEntityName, infoFormatter,
  infoFormatterIntl, localeFormatter, timeFormatter, userFIOFormatter,
  vehicleRegisterStatusFormatter,
} from '../../../utils/formatters';
import { responseLogWithNotification } from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { loadInformationById } from '../../InformationLog/actions';
import { getInformationData } from '../../InformationLog/reducer';
import FileView from '../../../components/fields/FileInput/FileView';
import { Accordion } from '../../../components/base/Accordion/Accordion';

export default function InformationPopUp(props) {
  const {
    id,
  } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    loadingCurrentInformation,
    currentInformation = {
      inf: {},
    },
  } = useSelector(getInformationData);

  const { inf: data } = currentInformation;

  useEffect(() => {
    dispatch(loadInformationById(id)).catch(responseLogWithNotification);
  }, [id]);

  const downloadJson = (data, filename = 'data.json') => {
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  const formMeta = {};

  const type = Object.values(IN_REQUEST_INF_TYPE_ENUM).includes(currentInformation?.inf_type) ? currentInformation?.inf_type : null;

  return (
    <div className={classNames('full-view custom-scroll-theme')}>
      <Loader loading={loadingCurrentInformation} />
      <div className="full-view-header">
        <div>{formatMessage({ id: loadingCurrentInformation ? 'app.loading' : `in_request_inf.type.${type}` })}</div>
        <Icons onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.INFORMATION_DETAIL, id })))} customIcon icon="close" />
      </div>
      <div className="full-view-content">
        <div className="download-json-button" onClick={() => downloadJson(currentInformation?.inf, `${currentInformation?.inf_type}_${currentInformation?.inf_id}.json`)}>{formatMessage({ id: 'download_json_button' })}</div>
        <div className="hr-row mb-4" />
        {infoFormatterIntl('in_request_inf.inf_id', currentInformation?.inf_id, 12)}
        { type === IN_REQUEST_INF_TYPE_ENUM.VEHICLE
          ? (
            <>
              <Row className="row-cols-2">
                {infoFormatterIntl('vehicle.external_id', data?.vehicle_external_id)}
                {infoFormatterIntl('vehicle_brand', data?.vehicle_brand)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('vehicle_model', data?.vehicle_model)}
                {infoFormatterIntl('Номер записи в реестре ЛТ', data?.vehicle_registry_number)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('vehicle_lpn', data?.vehicle_lpn)}
                {infoFormatterIntl('vehicle_vin', data?.vehicle_vin)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('carrier.external_id', data?.carrier_external_id)}
                {infoFormatterIntl('vehicle_color', data?.vehicle_color)}
              </Row>
              <Row className="row-cols-1">
                {infoFormatterIntl('Статус ТС', vehicleRegisterStatusFormatter(data?.vehicle_status))}
              </Row>
            </>
          ) : null}
        { type === IN_REQUEST_INF_TYPE_ENUM.OSAGO
          ? (
            <>
              <Row className="row-cols-3">
                {infoFormatterIntl('vehicle.external_id', data?.vehicle_external_id)}
                {infoFormatterIntl('insurance_contract_series', data?.vehicle_osago_series)}
                {infoFormatterIntl('insurance_contract_number', data?.vehicle_osago_number)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('insurance_contract_effective_date', dateFormatter(data?.vehicle_osago_valid_from_date))}
                {infoFormatterIntl('insurance_contract_expiration_date', dateFormatter(data?.vehicle_osago_valid_until_date))}
              </Row>
            </>
          ) : null}
        { type === IN_REQUEST_INF_TYPE_ENUM.OSGOP
          ? (
            <>
              <Row className="row-cols-2">
                {infoFormatterIntl('carrier.external_id', data?.carrier_external_id)}
                {infoFormatterIntl('osgop_insurance_contract_number', data?.vehicle_osgop_number)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('osgop_insurance_contract_effective_date', dateFormatter(data?.vehicle_osgop_valid_from_date))}
                {infoFormatterIntl('osgop_insurance_contract_expiration_date', dateFormatter(data?.vehicle_osgop_valid_until_date))}
              </Row>
            </>
          ) : null}
        { type === IN_REQUEST_INF_TYPE_ENUM.LOCATION
          ? (
            <>
              <Row className="row-cols-3">
                {infoFormatterIntl('vehicle.external_id', data?.vehicle_external_id)}
                {infoFormatterIntl('vehicle_terminal_id', data?.vehicle_terminal_id)}
                {infoFormatterIntl('vehicle_datetime_at', dateTimeFormatter(data?.vehicle_datetime_at))}
              </Row>
              <Row className="row-cols-3">
                {infoFormatterIntl('latitude', data?.vehicle_latitude)}
                {infoFormatterIntl('longitude', data?.vehicle_longitude)}
                {infoFormatterIntl('vehicle_speed', data?.vehicle_speed)}
              </Row>
              <Row className="row-cols-1">
                {infoFormatterIntl('vehicle_travel_angle', data?.vehicle_travel_angle)}
              </Row>
            </>
          ) : null}
        { type === IN_REQUEST_INF_TYPE_ENUM.TRIP
          ? (
            <>
              <Row className="row-cols-1">
                {infoFormatterIntl('carrier.external_id', data?.carrier_external_id)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('visit.start_date_time', dateTimeFormatter(data?.trip_started_at))}
                {infoFormatterIntl('visit.end_date_time', dateTimeFormatter(data?.trip_ended_at))}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('visit.start_point_lat', data?.trip_start_point?.[0])}
                {infoFormatterIntl('visit.start_point_lon', data?.trip_start_point?.[1])}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('visit.end_point_lat', data?.trip_end_point?.[0])}
                {infoFormatterIntl('visit.end_point_lon', data?.trip_end_point?.[0])}
              </Row>
              <Row className="row-cols-1">
                {infoFormatterIntl('trip_cost', data?.trip_cost)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('driver.external_id', data?.driver_external_id)}
                {infoFormatterIntl('vehicle.external_id', data?.vehicle_external_id)}
              </Row>
            </>
          ) : null}
        { type === IN_REQUEST_INF_TYPE_ENUM.TARIFF
          ? (
            <Row className="row-cols-2 mb-2">
              {infoFormatterIntl('media.tariff_file', data?.tariff_file ? <FileView readOnly withoutMime withoutHr files={data?.tariff_file} /> : null, {}, '', 12)}
            </Row>
          ) : null}
        { type === IN_REQUEST_INF_TYPE_ENUM.MEDICAL_EXAM
          ? (
            <>
              <Row className="row-cols-1">
                {infoFormatterIntl('Номер разрешения перевозчика (опционально)', data?.carrier_registry_number)}
              </Row>
              <Row className="row-cols-1">
                {infoFormatterIntl('ИНН Перевозчика', data?.carrier_inn)}
              </Row>
              <Row className="row-cols-1">
                {infoFormatterIntl('pre_trip_medical_examination', data?.pre_trip_medical_exam_using ? 'Используется' : 'Не используется')}
              </Row>
              <Row className="row-cols-1">
                {infoFormatterIntl('post_trip_medical_examination', data?.post_trip_medical_exam_using ? 'Используется' : 'Не используется')}
              </Row>
              <Row className="row-cols-1">
                {infoFormatterIntl('pre_techical_inspection', data?.pre_trip_technical_inspection_using ? 'Используется' : 'Не используется')}
              </Row>
            </>
          ) : null}
        { type === IN_REQUEST_INF_TYPE_ENUM.CARRIAGE_CONTRACT
          ? (
            <>
              <Row className="row-cols-2">
                {infoFormatterIntl('Номер разрешения перевозчика (опционально)', data?.carrier_registry_number)}
                {infoFormatterIntl('ИНН Перевозчика', data?.carrier_inn)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('carriage_contract_effective_date', dateFormatter(data?.carriage_contract_effective_date))}
                {infoFormatterIntl('carriage_contract_expiration_date', dateFormatter(data?.carriage_contract_expiration_date))}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('carriage_contract_number', data?.carriage_contract_number)}
                {infoFormatterIntl('Номер(-а) реестровой(-ых) записи(-ей) ЛТ для договора обеспечения', data?.vehicle_registry_numbers)}
              </Row>
              <Row className="row-cols-1 mb-2">
                {infoFormatterIntl('carriage_file', data?.carriage_file ? <FileView readOnly withoutMime withoutHr files={data?.carriage_file} /> : null, {}, '', 12)}
              </Row>
            </>
          ) : null}
        { type === IN_REQUEST_INF_TYPE_ENUM.DRIVER
          ? (
            <>
              <Row className="row-cols-2">
                {infoFormatterIntl('last_name', data?.driver_last_name)}
                {infoFormatterIntl('first_name', data?.driver_first_name)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('middle_name', data?.driver_middle_name)}
                {infoFormatterIntl('vehicle.external_id', data?.driver_external_id)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('inn', data?.driver_inn)}
                {infoFormatterIntl('birth_date', dateFormatter(data?.driver_birth_date))}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('citizenship', localeFormatter('citizenship.type', data?.driver_citizenship))}
                {infoFormatterIntl('phone', data?.driver_phone)}
              </Row>
              <Row className="row-cols-1">
                {infoFormatterIntl('email', data?.driver_email)}
              </Row>
              <div className="mb-2" />
              <Accordion
                isOpen
                content={(
                  <>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('identity_type', localeFormatter('identity.type', data?.driver_identity_type))}
                      {infoFormatterIntl('identity_series', data?.driver_identity_series)}
                    </Row>
                    <Row className="row-cols-1">
                      {infoFormatterIntl('identity_number', data?.driver_identity_number)}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('email', data?.driver_email)}
                      {infoFormatterIntl('identity_issue_date', dateFormatter(data?.driver_identity_issue_date))}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('identity_issuer', data?.driver_identity_issuer)}
                      {infoFormatterIntl('identity_issuer_code', data?.driver_identity_issuer_code)}
                    </Row>
                    <Row className="row-cols-1">
                      {infoFormatterIntl('place_of_birth', data?.driver_birth_place)}
                    </Row>
                    <Row className="row-cols-1 mb-2">
                      {infoFormatterIntl('driver_photo_with_identity', data?.driver_photo_with_identity ? <FileView readOnly withoutMime withoutHr files={data?.driver_photo_with_identity} /> : null, {}, '', 12)}
                    </Row>
                  </>
                  )}
                title="Документ, удостоверяюший личность водителя"
              />
              <Accordion
                isOpen
                content={(
                  <>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('driver_license_series', data?.driver_license_series)}
                      {infoFormatterIntl('driver_license_number', data?.driver_license_number)}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('driver_license_valid_from_date', dateFormatter(data?.driver_license_valid_from_date))}
                      {infoFormatterIntl('expiration_date', dateFormatter(data?.driver_license_valid_until_date))}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('issue_created_at', dateFormatter(data?.driver_license_issue_date))}
                      {infoFormatterIntl('driver_license_issuer', data?.driver_license_issuer)}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('driver_license_experience', data?.driver_license_experience)}
                      {infoFormatterIntl('driver_license_issuer_country', data?.driver_license_issuer_country)}
                    </Row>
                    <Row className="row-cols-1 mb-2">
                      {infoFormatterIntl('media.driver_license_files', data?.driver_license_files ? <FileView readOnly withoutMime withoutHr files={data?.driver_license_files} /> : null, {}, '', 12)}
                    </Row>
                  </>
                  )}
                title="Водительское удостоверение"
              />
              <Accordion
                isOpen
                content={(
                  <>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('criminal_record_series', data?.driver_criminal_record_series)}
                      {infoFormatterIntl('criminal_record_number', data?.driver_criminal_record_number)}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('criminal_record_issue_date', dateFormatter(data?.driver_criminal_record_issue_date))}
                      {infoFormatterIntl('criminal_record_issuer', data?.driver_criminal_record_issuer)}
                    </Row>
                    <Row className="row-cols-1 mb-2">
                      {infoFormatterIntl('criminal_record_scan', data?.driver_criminal_record_scan ? <FileView readOnly withoutMime withoutHr files={data?.driver_criminal_record_scan} /> : null, {}, '', 12)}
                    </Row>
                  </>
                  )}
                title="Справка о наличии (отсутствии) судимости и (или) факта уголовного преследования либо о прекращении уголовного преследования"
              />
            </>
          ) : null}
        { type === IN_REQUEST_INF_TYPE_ENUM.WAYBILL
          ? (
            <>
              <Row className="row-cols-2">
                {infoFormatterIntl('issue_start', dateFormatter(data?.waybill_dispatched_at))}
                {infoFormatterIntl('issue_end_way', dateTimeFormatter(data?.waybill_returned_at))}
              </Row>
              <Accordion
                title="Медицинский осмотр"
                content={(
                  <>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('pre_trip_medical_examination', data?.waybill_pre_trip_medical_exam_result)}
                      {infoFormatterIntl('pre_trip_responsible', data?.waybill_medical_examiner)}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('pre_trip_date', dateFormatter(data?.waybill_pre_trip_medical_exam_at))}
                      {infoFormatterIntl('pre_trip_time', timeFormatter(data?.waybill_pre_trip_medical_exam_at))}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('post_trip_medical_examination', data?.waybill_post_trip_medical_exam_result)}
                      {infoFormatterIntl('post_trip_responsible', data?.waybill_post_medical_examiner)}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('post_trip_date', dateFormatter(data?.waybill_post_trip_medical_exam_at))}
                      {infoFormatterIntl('post_trip_time', timeFormatter(data?.waybill_post_trip_medical_exam_at))}
                    </Row>
                  </>
                      )}
              />
              <Accordion
                title="Состояние автомобиля"
                content={(
                  <>
                    <Row className="row-cols-1">
                      {infoFormatterIntl('pre_trip_control', data?.waybill_pre_trip_inspection_result)}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('post_trip_control_date', dateFormatter(data?.waybill_pre_trip_inspection_at))}
                      {infoFormatterIntl('post_trip_control_time', timeFormatter(data?.waybill_pre_trip_inspection_at))}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('technical_condition_control', dateFormatter(data?.waybill_pre_trip_inspection_at))}
                      {infoFormatterIntl('mechanic', data?.waybill_technical_inspection_controllers_info)}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('odometer_before_trip', data?.waybill_odometer_dispatch)}
                      {infoFormatterIntl('odometer_after_trip', data?.waybill_odometer_return)}
                    </Row>
                  </>
                )}
              />
              <Accordion
                title="Отметки"
                content={(
                  <Row className="row-cols-2">
                    {infoFormatterIntl('waybill_transportation_type', data?.waybill_transportation_type)}
                    {infoFormatterIntl('waybill_route_type', data?.waybill_route_type)}
                  </Row>
                )}
              />
            </>
          ) : null}
        { type === IN_REQUEST_INF_TYPE_ENUM.CARRIER
          ? (
            <>
              <Row className="row-cols-1">
                {infoFormatterIntl('legal_entity_type', localeFormatter('user.type', data?.carrier_type), {}, 'applicant.legal_entity_type')}
              </Row>
              <Row className="row-cols-1">
                {infoFormatterIntl('carrier.external_id', data?.carrier_external_id, {}, 'applicant.legal_entity_type')}
              </Row>
              {Number(data?.carrier_type) === USER_TYPE.LEGAL ? (
                <>
                  <Row className="row-cols-2">
                    {infoFormatterIntl('legal_entity_form', data?.carrier_legal_entity_form, formMeta, 'legal_entity_form')}
                    {infoFormatterIntl('short_name_legal', data?.carrier_short_name, formMeta, 'short_name')}
                  </Row>
                  <Row className="row-cols-1">
                    {infoFormatterIntl('full_name_legal', getLegalEntityName({
                      legal_entity_type: Number(data?.carrier_type),
                      short_name: data?.carrier_full_name,
                    }), formMeta, 'full_name')}
                  </Row>
                  <Row className="row-cols-1">
                    {infoFormatterIntl('address', data?.carrier_address, formMeta, 'address')}
                  </Row>
                  <Row className="row-cols-1">
                    {infoFormatterIntl('legal_address', data?.carrier_ur_address, formMeta, 'legal_address')}
                  </Row>
                  <Row className="row-cols-2">
                    {infoFormatterIntl('inn', data?.carrier_inn, formMeta, 'inn')}
                    {infoFormatterIntl('ogrn', data?.carrier_ogrn, formMeta, 'ogrn')}
                  </Row>
                  <Row className="row-cols-2">
                    {infoFormatter('ФИО руководителя', userFIOFormatter({
                      last_name: data?.carrier_supervisor_last_name,
                      first_name: data?.carrier_supervisor_first_name,
                      middle_name: data?.carrier_supervisor_middle_name,
                    }), formMeta, ['carrier_supervisor_last_name', 'carrier_supervisor_first_name', 'carrier_supervisor_middle_name'])}
                  </Row>
                  <Row className="row-cols-2">
                    {infoFormatterIntl('phone', data?.carrier_phone, formMeta, 'phone')}
                    {infoFormatterIntl('pd.email', data?.carrier_email, formMeta, 'email')}
                  </Row>
                </>
              ) : (
                <>
                  <Row className={Number(data?.carrier_type) === USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? 'row-cols-2' : 'row-cols-1'}>
                    {infoFormatterIntl('inn', data?.carrier_inn, formMeta, 'inn')}
                    {Number(data?.carrier_type) === USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? infoFormatterIntl('ogrnip', data?.carrier_ogrn, formMeta, 'ogrn') : null}
                  </Row>
                  <Row className="row-cols-1">
                    {infoFormatterIntl('ФИО', getLegalEntityName({
                      legal_entity_type: Number(data?.carrier_type),
                      last_name: data?.carrier_last_name,
                      first_name: data?.carrier_first_name,
                      middle_name: data?.carrier_middle_name,
                    }), formMeta, 'full_name')}
                  </Row>
                  <Row className="row-cols-2">
                    {infoFormatterIntl('birth_date', dateFormatter(data?.carrier_birth_date), formMeta, 'birth_date')}
                    {infoFormatterIntl('place_of_birth', data?.carrier_birth_place, formMeta, 'place_of_birth')}
                  </Row>
                  <Row className="row-cols-2">
                    {infoFormatterIntl('gender', formatMessage({ id: `gender.${data?.carrier_gender}`, defaultMessage: data?.carrier_gender || ' ' }), formMeta, 'gender')}
                    {infoFormatterIntl('citizenship', formatMessage({ id: `citizenship.type.${data?.carrier_citizenship}`, defaultMessage: data?.carrier_citizenship || ' ' }), formMeta, 'citizenship')}
                  </Row>
                  <Row className="row-cols-2">
                    {infoFormatterIntl('snils', data?.carrier_snils, formMeta, 'snils')}
                    {infoFormatterIntl('registration_type', formatMessage({ id: `registration.type.${data?.carrier_reg_type}`, defaultMessage: data?.carrier_reg_type || ' ' }), formMeta, 'registration_type')}
                  </Row>
                  <Row className="row-cols-2">
                    {infoFormatterIntl('phone', data?.carrier_phone, formMeta, 'phone')}
                    {infoFormatterIntl('pd.email', data?.carrier_email, formMeta, 'email')}
                  </Row>
                  <Row className="row-cols-2">
                    {infoFormatterIntl('identity_type_short', formatMessage({ id: `identity.type.${data?.carrier_identity_type}`, defaultMessage: data?.carrier_identity_type || ' ' }), formMeta, 'identity_type')}
                    {infoFormatterIntl('identity_issue_date', dateFormatter(data?.carrier_identity_issue_date), formMeta, 'identity_issue_date')}
                  </Row>
                  <Row className="row-cols-2">
                    {infoFormatterIntl('identity_series', data?.carrier_identity_series, formMeta, 'identity_series')}
                    {infoFormatterIntl('identity_number', data?.carrier_identity_number, formMeta, 'identity_number')}
                  </Row>
                  <Row className="row-cols-2">
                    {infoFormatterIntl('identity_issuer_code', data?.carrier_identity_issuer_code, formMeta, 'identity_issuer_code')}
                    {infoFormatterIntl('criminal_record_certificate_info_doc', data?.carrier_criminal_record, formMeta, 'criminal_record_certificate_info_doc')}
                  </Row>
                  <Row className="row-cols-1">
                    {infoFormatterIntl('identity_issuer', data?.carrier_identity_issuer, formMeta, 'identity_issuer')}
                  </Row>
                  {
                    Number(data?.carrier_type) === USER_TYPE.INDIVIDUAL_ENTREPRENEUR
                      ? (
                        <Row className="row-cols-2">
                          {infoFormatterIntl('address', data?.carrier_office_address, formMeta, 'office_address')}
                          {infoFormatterIntl('address_registration_entrepreneur', data?.carrier_address, formMeta, 'address')}
                        </Row>
                      ) : (
                        <Row className="row-cols-1">
                          {infoFormatterIntl('registration_address', data?.carrier_address, formMeta, 'address')}
                        </Row>
                      )
                  }
                </>
              )}
            </>
          ) : null}
      </div>
    </div>
  );
}
